import React, { Component } from 'react';

export default class Checkbox extends Component {
  render() {
    return (
        <label className={`${this.props.disapled ? 'checkbox disapled' : 'checkbox'}`}>
            <input type="checkbox" name={this.props.name} onChange={this.props.onChange} defaultChecked={this.props.defaultChecked}/>
            <span className="name">{this.props.text}</span>
            <span className="check-icon"></span>
        </label>
    );
  }
}
